import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, createSlots as _createSlots, Fragment as _Fragment, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "product-gallery__video"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "image-element" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "carousel product-gallery__big-images" }
const _hoisted_7 = { class: "carousel__wrapper" }
const _hoisted_8 = { class: "carousel__container" }
const _hoisted_9 = { class: "carousel__slide carousel__slide--active" }
const _hoisted_10 = { class: "product-gallery__image-wrapper slide-0" }
const _hoisted_11 = { class: "product-gallery__picture--three-view-wrapper" }
const _hoisted_12 = { class: "product-gallery__video-play-btn-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_video_player = _resolveComponent("video-player")!
  const _component_image_element = _resolveComponent("image-element")!
  const _component_carousel = _resolveComponent("carousel")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-gallery", {
      'product-gallery--center-right': _ctx.centerRight(),
      'product-gallery--has-video': _ctx.productDetails.videoViewmodels.length,
      'product-gallery--has-many-videos': _ctx.productDetails.videoViewmodels.length > 1,
      'product-gallery--has-too-much-items': _ctx.carouselItems.length > 3,
      'product-gallery--thumb-slider': _ctx.carouselItems.length > 4,
      'product-gallery--single-item': _ctx.carouselItems.length === 1,
      'product-gallery--three-view': _ctx.isThreePicView,
      'product-detailed-page--no-scale': _ctx.isFallbackImage || _ctx.productDetails.isSet
    }]),
    role: "img"
  }, [
    (!_ctx.isThreePicView)
      ? (_openBlock(), _createBlock(_component_carousel, {
          key: 0,
          class: "product-gallery__big-images",
          "slides-count": _ctx.pictureCount,
          "slides-per-view-desktop": 1,
          "slides-per-view-mobile": 1,
          "slides-per-view-tablet": 1,
          "show-pagination": true,
          thumbnails: _ctx.thumbnails,
          options: {
        spaceBetween: 8
      },
          onChange: _ctx.onCarouselChange,
          ref: "carouselRef"
        }, _createSlots({ _: 2 /* DYNAMIC */ }, [
          _renderList(_ctx.carouselItems, (item, index) => {
            return {
              name: `slide-${index}`,
              fn: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(`product-gallery__image-wrapper slide-${index}`),
                  onClick: ($event: any) => (_ctx.imageClickHandler(index))
                }, [
                  (item.videoId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_video_player, {
                          "video-data": item,
                          ref: "videoPlayersRef",
                          onPlayFromStart: ($event: any) => (_ctx.trackVideoPlay(item))
                        }, null, 8 /* PROPS */, ["video-data", "onPlayFromStart"])
                      ]))
                    : (_openBlock(), _createBlock(_resolveDynamicComponent(index === 0 ? 'div' : 'lazy-load'), { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_image_element, {
                            class: _normalizeClass(["product-gallery__picture", {'product-gallery__picture--no-zoom': !_ctx.enableZoom}]),
                            "picture-class": _ctx.imageClass,
                            "img-class": "product-gallery__image product-gallery__image--auto-center",
                            src: item.bigRetina ? [item.big, item.bigRetina] : [item.big],
                            "src-mobile": item.bigRetina ? [item.bigMobile, item.bigRetinaMobile] : [item.bigMobile],
                            alt: _ctx.productDetails.product.name,
                            loading: index === 0 ? 'eager' : 'lazy',
                            webp: true
                          }, null, 8 /* PROPS */, ["class", "picture-class", "src", "src-mobile", "alt", "loading"])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */))
                ], 10 /* CLASS, PROPS */, _hoisted_1)
              ])
            }
          })
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["slides-count", "thumbnails", "onChange"]))
      : _createCommentVNode("v-if", true),
    _cache[3] || (_cache[3] = _createTextVNode()),
    (_ctx.thumbnails && _ctx.thumbnails.length > 4 && !_ctx.isThreePicView)
      ? (_openBlock(), _createBlock(_component_carousel, {
          key: 1,
          class: "carousel__thumbnail-slider-wrapper",
          "slides-count": _ctx.thumbnails.length,
          "slides-per-view-desktop": 4,
          "slides-per-view-mobile": 4,
          "slides-per-view-tablet": 4,
          "show-pagination": false,
          options: {
        spaceBetween: 5,
        slidesPerView: 4,
        slidesPerGroup: 1,
        centeredSlides: true,
        speed: 300,
      },
          ref: "carouselThumbRef",
          onChange: _ctx.onCarouselChange
        }, _createSlots({ _: 2 /* DYNAMIC */ }, [
          _renderList(_ctx.thumbnails, (thumb, index) => {
            return {
              name: `slide-${index}`,
              fn: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(`carousel__thumbnail-button slide-${index}`),
                  onClick: ($event: any) => (_ctx.thumbClickHandler(index))
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_4, [
                      _createElementVNode("img", {
                        src: thumb.src,
                        alt: thumb.name,
                        width: "70",
                        height: "70",
                        loading: "eager",
                        class: "image-element__img"
                      }, null, 8 /* PROPS */, _hoisted_5)
                    ])
                  ])
                ], 10 /* CLASS, PROPS */, _hoisted_3)
              ])
            }
          })
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["slides-count", "onChange"]))
      : _createCommentVNode("v-if", true),
    _cache[4] || (_cache[4] = _createTextVNode()),
    (_ctx.isThreePicView)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_image_element, {
                        class: _normalizeClass(["product-gallery__picture", {'product-gallery__picture--no-zoom': !_ctx.enableZoom}]),
                        "picture-class": _ctx.imageClass,
                        "img-class": "product-gallery__image product-gallery__image--auto-center",
                        src: _ctx.carouselItems[0].bigRetina ? [_ctx.carouselItems[0].big, _ctx.carouselItems[0].bigRetina] : [_ctx.carouselItems[0].big],
                        "src-mobile": _ctx.carouselItems[0].bigRetina ? [_ctx.carouselItems[0].bigMobile, _ctx.carouselItems[0].bigRetinaMobile] : [_ctx.carouselItems[0].bigMobile],
                        alt: _ctx.productDetails.product.name,
                        loading: "eager",
                        webp: true,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imageClickHandler(0)))
                      }, null, 8 /* PROPS */, ["class", "picture-class", "src", "src-mobile", "alt"])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _cache[2] || (_cache[2] = _createTextVNode()),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slicedThreePicImages, (thumb, index) => {
              return (_openBlock(), _createBlock(_component_image_element, {
                key: `${index}-thumb`,
                class: _normalizeClass(["product-gallery__picture product-gallery__picture--three-view", [{'product-gallery__picture--no-zoom': !_ctx.enableZoom}, `product-gallery__picture--three-view-${index}`]]),
                "picture-class": _ctx.imageClass,
                "img-class": "product-gallery__image product-gallery__image--auto-center",
                src: thumb.bigRetina ? [thumb.big, thumb.bigRetina] : [thumb.big],
                "src-mobile": thumb.bigRetina ? [thumb.bigMobile, thumb.bigRetinaMobile] : [thumb.bigMobile],
                alt: _ctx.productDetails.product.name,
                loading: "lazy",
                webp: true
              }, null, 8 /* PROPS */, ["class", "picture-class", "src", "src-mobile", "alt"]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _cache[5] || (_cache[5] = _createTextVNode()),
    (_ctx.productDetails.videoViewmodels.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "product-gallery__video-play-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.playVideo()))
        }, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t(_ctx.productDetails.videoViewmodels.length > 1 ? 'ads.ads_top_info.playVideo.many' : 'ads.ads_top_info.playVideo')), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}